/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import Component from "@glimmer/component";
import { ProtocolSectionArgs } from "../../base-components/base-protocol-item";
export default class TreatmentHistoryDefaultHormonotherapyComponent extends Component {
  get hormonotherapyTypes() {
    return ["anti-aromatase", "femara", "tamoxifen", "sequential"];
  }
}